import InfoAndImageCard from './info-and-image-card'

export default InfoAndImageCard
